import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, props ) => ( {
	nameAndCommentContainerInNormalChat: {
		// padding      : "0.5rem 0rem 1rem 1rem",
		padding      : "0.5rem 1rem",
		display      : "flex",
		fontSize     : "1.2rem",
		paddingRight : "1rem",

		"& .optionsButtonInChat": {
			opacity: props?.isPopUpOpen ? "1" : "0"
		},

		"&:hover": {
			backgroundColor          : theme.other.darkMode ? theme.other.paletteNew.darkModeInclinedBlack2 : theme.other.paletteNew.secondaryBackgroundGrey,
			"& .optionsButtonInChat" : {
				opacity: "1"
			}
		}
	},
	userNameAndCommentInMagicChat: {
		padding    : "0px 0.8rem",
		alignItems : "center",
		// marginTop  : "0.5rem"
		marginTop  : "0.1rem"
	},
	commentText: {
		color      : theme.other.colors.text.primary,
		wordBreak  : "break-word",
		// fontWeight : 500,
		fontSize   : "1.3rem",
		lineHeight : "1.75"
	},
	showOptionsButton: {
		width      : "2.25rem",
		cursor     : "pointer",
		height     : "2.25rem",
		marginTop  : "0.5rem",
		marginLeft : "0.5rem"
	},
	svgIcon: {
		height: "20px"

	}
} ) );
